import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    configurationUrl: String,
  };

  connect() {
    this.element.classList.add(
      'article-extras-podigee__container',
      'hidden@print'
    );
  }

  load() {
    this.element.innerHTML = '';
    const script = document.createElement('script');
    script.src =
      '//cdn.podigee.com/podcast-player/javascripts/podigee-podcast-player.js';
    script.classList.add('podigee-podcast-player');
    script.dataset.configuration = this.configurationUrlValue;
    this.element.insertAdjacentElement('afterbegin', script);
  }
}
